export { default } from "./addAdditionalInfoToProseMirrorNode";
